import { useState, useCallback, useEffect } from 'react';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';

const MemberList = ({ searchObjHandler }) => {
  const [emailRequestText, setEmailRequestText] = useState('');

  const [searchMemberObj, setSearchMemberObj] = useState({
    type: 'All',
    searchText: '',
  });

  const onChangeEmailHandler = useCallback((event) => {
    const { value } = event.target;
    setEmailRequestText(value);
  }, []);

  // /api/common/postRequest'
  const sendEmailHandler = useCallback(async () => {
    const { data, status, statusText } = await axiosDummyInstance.get('/api/common/postRequest', {
      params: { email: emailRequestText },
    });
    if (status === 200) {
      alert('email sent complete');
    } else {
      alert(`${statusText} error occur`);
    }
  }, [emailRequestText]);

  const onChangeHandler = useCallback((event) => {
    const { name, value } = event.target;
    if (name === 'select') {
      setSearchMemberObj((prev) => ({ ...prev, type: value }));
    } else if (name === 'search') {
      setSearchMemberObj((prev) => ({ ...prev, searchText: value }));
    }
  }, []);

  const onMemberSearchHandler = useCallback(() => {
    if (searchMemberObj.searchText.trim().length === 0) {
      alert('Please enter your search term');
    }
    searchObjHandler(searchMemberObj);
  }, [searchMemberObj]);

  return (
    <>
      <h3 className="t-manager-stit">Invite Team Members</h3>
      <div className="serach-box team">
        <label className="ipt">
          <input type="text" placeholder="" value={emailRequestText} onChange={onChangeEmailHandler} />
        </label>
        <button type="button" className="btn-s pri" onClick={sendEmailHandler}>
          Send
        </button>
      </div>
      <h3 className="t-manager-stit">All Manager</h3>
      <form>
        <div className="serach-box team">
          <label className="select">
            <select name="select" onChange={onChangeHandler}>
              <option value={'all'}>Search Type</option>
              <option value={'email'}>Member Email</option>
              <option value={'role'}>Member Role</option>
              <option value={'status'}>Member Status</option>
            </select>
          </label>
          <label className="ipt">
            <input
              type="text"
              placeholder=""
              value={searchMemberObj.searchText}
              name="search"
              onChange={onChangeHandler}
            />
          </label>
          <button type="button" className="btn-s pri" onClick={onMemberSearchHandler}>
            Member Search
          </button>
        </div>
      </form>
    </>
  );
};

export default MemberList;
